'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVisitorId = exports.getValidator = exports.maskPIIData = exports.shouldShowAvatar = exports.getDelayFromMessage = exports.BOT_TYPING_DELAY = exports.BOT_RESPONSE_DELAYS = undefined;

var _responseUtils = require('./response-utils');

var _responseUtils2 = _interopRequireDefault(_responseUtils);

var _util = require('@ux/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BOT_RESPONSE_DELAYS = exports.BOT_RESPONSE_DELAYS = {
  short: { length: 0, time: 2000 },
  medium: { length: 100, time: 3000 },
  long: { length: 200, time: 4000 }
};

var BOT_TYPING_DELAY = exports.BOT_TYPING_DELAY = 500;

/**
 * @returns {number} Delay in milliseconds
 *
 * @param {Object} message The dialog message (conversation item)
 * @public
 */
var getDelayFromMessage = exports.getDelayFromMessage = function getDelayFromMessage(message) {
  var messageTextLength = _responseUtils2.default.getMessageText(message).length;

  var short = BOT_RESPONSE_DELAYS.short,
      medium = BOT_RESPONSE_DELAYS.medium,
      long = BOT_RESPONSE_DELAYS.long;

  var delay = short.time;
  if (messageTextLength >= medium.length && messageTextLength < long.length) delay = medium.time;else if (messageTextLength >= long.length || message.msgType === 'search') delay = long.time;

  return message.msgType === 'text' || message.msgType === 'api' || message.msgType === 'button' || message.msgType === 'search' ? delay : 0;
};

/**
 * @returns {boolean} return boolean value whether to hide avatar
 *
 * @param {array} conversation the bot conversation from staate
 * @param {number} index the message index in the conversation
 * @public
 */
var shouldShowAvatar = exports.shouldShowAvatar = function shouldShowAvatar(conversation, index) {
  var nextItem = conversation[index + 1];
  var nextItemIsBot = nextItem && ['image', 'search', 'text'].indexOf(nextItem.msgType) > -1;
  return !nextItemIsBot;
};

var maskPIIData = exports.maskPIIData = function maskPIIData(text) {
  if (!text) return text;
  return text.replace(/\d{3}/g, 'XXX').replace(/XXX\d{1}/g, 'XXXX').replace(/\b[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}\b/, 'XXXXXXX@XXXX.XXX');
};

var phoneValidator = function phoneValidator(text) {
  // supported phone format are xxxxxxxxxx and xxx-xxx-xxxx

  return text.match(/^\d{10}$/) || text.match(/^\d{3}-\d{3}-\d{4}$/);
};

var getValidator = exports.getValidator = function getValidator(type) {
  if (type === 'phone') {
    return phoneValidator;
  }
  return function () {
    return true;
  };
};

var getVisitorId = exports.getVisitorId = function getVisitorId() {
  var visitor = _util.cookie.get('visitor');
  return visitor && visitor.length > 4 ? visitor.split('=')[1] : '';
};